import { CartInputValidators } from '../types/cart-validator.types';


export const cartInputValidators: CartInputValidators = {
  contractCode: {
    maxLength: 10,
    min: null,
    max: null
  },
  openText: {
    maxLength: 40,
    min: null,
    max: null
  },
  partNumber: {
    maxLength: 35,
    min: null,
    max: null
  },
  connectCode: {
    maxLength: null,
    min: 1,
    max: 8
  }
};
